import { useState } from 'react';
import axios from 'axios';
import { track } from '../../lib/analytics';
import { toast } from 'sonner';
import { Bell, Loader2, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ComingSoon = ({ section }) => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const testId = section.toLowerCase().replace(/\s+/g, '-');
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await axios.post(`${API}/waitlist`, { email, country: section }); track('sign_up', { method: 'waitlist', country: section }); setDone(true); }
    catch { toast.error('Please enter a valid email address'); }
    setBusy(false);
  };
  return (
    <div className="rounded-3xl border border-dashed border-[#C5A059]/50 bg-[#F5EFE9] p-10 text-center" data-testid={`coming-soon-${testId}`}>
      <p className="font-display text-2xl text-[#1E1622] mb-2">Coming soon</p>
      <p className="text-sm text-[#1E1622]/60 max-w-md mx-auto mb-6">New {section.toLowerCase()} are on the way. Leave your email and we'll tell you as soon as they're published.</p>
      {done ? (
        <p className="text-sm text-[#3B164C] inline-flex items-center gap-2" data-testid={`coming-soon-done-${testId}`}><Check size={16} /> You're on the list</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid={`coming-soon-email-${testId}`}
            className="flex-grow rounded-full px-5 py-3 text-sm bg-white border border-[#E6DAC5] focus:outline-none focus:border-[#C5A059]" />
          <button type="submit" disabled={busy} data-testid={`coming-soon-submit-${testId}`} className="btn-gold text-sm inline-flex items-center justify-center gap-2">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Bell size={14} />} Notify me
          </button>
        </form>
      )}
    </div>
  );
};
